import axios from 'axios'
import React, { useEffect, useState } from 'react'
import ReactPaginate from "react-paginate";
import * as XLSX from "xlsx";
import DatePicker from "react-multi-date-picker";
import { DateObject } from "react-multi-date-picker";
import { apiRequest } from '../store/allApi';
import Swal from "sweetalert2";


const $ = require("jquery")
$.Datatable = require("datatables.net");

function Earings() {

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    var baseUrl = beckendLiveApiUrl
  }

  //use for pagination..
  let [limit, setLimit] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);

  const setpageLimit = (event) => {
    let key = event.target.value
    setLimit(key);
  }

  const [EARING, setEARING] = useState()
  const [TOTELEARING, setTOTELEARING] = useState()

  const [values, setValues] = useState([
    new DateObject().subtract(4, "days"),
    new DateObject().add(4, "days")
  ])

  //react paginate..
  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setPageNumber(currentPage);
    // scroll to the top
    //window.scrollTo(0, 0)
  };


  const resetEarning = async (Id) => {
          const access_token = localStorage.getItem("token");
          const headers = {
              Authorization: `Bearer ${access_token}`,
          };
      
          // Show a confirmation dialog before proceeding with the API call
          const result = await Swal.fire({
              title: 'Are you sure?',
              text: "You won't be able to revert this!",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, reset it!',
              cancelButtonText: 'Cancel'
          });
      
          // If the user confirms, proceed with the API call
          if (result.isConfirmed) {
              try {
                  const res = await apiRequest(`api/admin/earning-zero`, "GET", null, headers);
      
                  if (res?.data?.status === true) {
                      Swal.fire({
                          title: res?.data?.msg,
                      });
                  } else if (res?.data?.status === false) {
                      Swal.fire({
                          title: res?.data?.msg,
                      });
                  }
              } catch (e) {
                  // Handle errors here
                  console.error(e);
              } finally {
                  // Any cleanup code goes here if needed
              }
          } else {
              // If user cancels, you can log or do something else
              console.log("User canceled the delete action");
          }
      };


  const earnings = async() => {
    const access_token = localStorage.getItem("token")
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
      try {
              const res = await apiRequest(`admin/Earning?page=${pageNumber}&_limit=${limit}&FROM_DATE=${values[0]}&TO_DATE=${values[1]}`,"GET", null,headers)
             if (res.data) {
              setEARING(res.data.admin)
              setNumberOfPages(res.data.totalPages)
             }
                } catch (e) {
                  // setLoading(false)
                }
                finally {
                }
      try {
              const res = await apiRequest(`admin/Earning/total`,"GET", null,headers)
             if (res.data) {
            //console.log(res.data.total)
        setTOTELEARING(res.data.total)
             }
                } catch (e) {
                  // setLoading(false)
                }
                finally {
                }
  }

    const dateFormat = e => {
  const date = new Date(e);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';

  hours = hours % 12 || 12; // convert to 12-hour format

  return `${day}-${month}-${year} at ${hours}:${minutes} ${ampm}`;
};

  useEffect(() => {
  
    earnings()
  }, [pageNumber, limit, values])

  const createDownloadData = () => {
    handleExport();
  };
  const handleExport = () => {
    let table1 = [
      {
        A: "id",
        B: "Amount"
        // F:"Bonus by (ID)"
      },
    ];

    EARING.forEach((row) => {
      const Earing = row;
      //console.log("exldata", Earing);
      table1.push({
        A: `Earn From Challange ${Earing.Earned_Form} on ${dateFormat(Earing.createdAt)}`,
        B: Earing.Ammount,
        // F:(userDetails.action_by)?userDetails.action_by:'N/A'
      });
    });

    //table1 = [{A:"User Details"}].concat(table1);
    //const finalData = [...table1];
    //console.log(finalData);
    /* convert state to workbook */
    const ws = XLSX.utils.json_to_sheet(table1, {
      skipHeader: true,
    });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
    /* generate XLSX file and send to client */
    XLSX.writeFile(wb, "AdminEarning.xlsx");
  };

  return (
    <>
      <div className="mt-3">
        <h3 className='d-flex flex-row text-light'>ADMIN TOTAL EARING : {TOTELEARING}</h3>
         <button
                                                                    onClick={() => resetEarning()}
                                                                    className="btn btn-danger"
                                                                >
                                                                    Reset Earing
                                                                </button>
        <select className='form-control col-sm-1 m-1  text-black' id='pagelimit' name='pagelimit' onChange={setpageLimit}>
          <option value="10">Set limit</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
          <option value="500">500</option>
        </select>
      </div>
      <div className='mb-3'>
        <button style={{marginRight:'10px'}}
          onClick={() => {
            createDownloadData();
          }}
          className="btn btn-primary"
        >
          Export Data
        </button>

        <DatePicker value={values} onChange={setValues} range />
      </div>
      <div className="row ">
        <div className="col-12 grid-margin">
          <div className="card text-white">
            <div className="card-body text-light"  >
              <div className="table-responsive">
                <table className="table text-black">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th> _id </th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {EARING && EARING.map((Earing, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          <div className="d-flex">
                            <span className="pl-2">Earn From Challange {Earing.Earned_Form} on {dateFormat(Earing.createdAt)}</span>
                          </div>
                        </td>

                        <td>
                          <div className="">{Earing.Ammount}</div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className='mt-4 bg-dark'>
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={numberOfPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Earings